import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  formInputLabel: {
    padding: 0,
    marginBottom: 8,
    fontSize: 14,
    lineHeight: '24px',
  },
  textFieldStyle: {
    '&.MuiTextField-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '12px 8px',
    },
  },
  wrapFormInput: {
    marginTop: 0,
    position: 'relative',
  },
}));

export default useStyles;
